package com.milta.feature.optimizationquota.domain.usecase

import com.milta.feature.optimizationquota.domain.entity.AdminAccountOptimizationQuota
import com.milta.feature.optimizationquota.domain.repository.OptimizationQuotaRepository

class GetAccountOptimizationQuotaUseCase(private val repository: OptimizationQuotaRepository) {
    suspend operator fun invoke(accountId: String): Result<AdminAccountOptimizationQuota> = repository.getAccountQuota(accountId)
}
